import {
  HrRequestGroupKey,
  HrRequestOption,
  HrRequestSlug,
  HrRequestSubType,
  HrRequestType,
} from '@/gql/generated';

export interface PopularRequestOption extends HrRequestOption {
  icon: string;
}

export interface RequestOption extends HrRequestOption {
  icon: string;
  credits: number;
  activeSubscription: boolean;
}

const CUSTOMER_SERVICE_TYPES = [
  HrRequestType.AdminSupport,
  HrRequestType.TechSupport,
  HrRequestType.Billing,
];

const CUSTOMER_SERVICE_SUB_TYPES = [HrRequestSubType.AppHelp];

const CUSTOMER_SERVICE_TYPES_API_NAMES = {
  [HrRequestType.AdminSupport]: 'ADMIN_SUPPORT',
  [HrRequestType.TechSupport]: 'TECH_SUPPORT',
  [HrRequestType.Billing]: 'BILLING',
};

const CUSTOMER_SERVICE_SUB_TYPE_API_NAMES = {
  [HrRequestSubType.AppHelp]: 'APP_HELP',
};

export const isCustomerServiceSubType = (subType) =>
  CUSTOMER_SERVICE_SUB_TYPES.includes(subType);

export const isCustomerServiceType = (type) =>
  CUSTOMER_SERVICE_TYPES.includes(type);

export const customerServiceTypeApiName = (type: HrRequestType) =>
  CUSTOMER_SERVICE_TYPES_API_NAMES[type] || type;

export const customerServiceSubTypeApiName = (subType: HrRequestSubType) =>
  CUSTOMER_SERVICE_SUB_TYPE_API_NAMES[subType] || subType;

export const hrRequestFullSlug = ({
  groupKey,
  slug,
}: {
  groupKey: HrRequestGroupKey;
  slug: HrRequestSlug;
}): string => {
  const fullSlug = `${groupKey}-${slug}`;

  // for backward compatibility
  return fullSlug.replace(/_/g, '-').toLowerCase();
};

export enum RequestStatus {
  PROGRESS = 'In Progress',
  SUBMITTED = 'Request Submitted',
  RESOLVED = 'Resolved',
  REQUIRE_ACTION = 'Action Needed',
  CANCELLED = 'Cancelled',
  CLOSED = 'Closed',
}

export enum RequestEvents {
  OPEN_CASE = 'my-request-open-case',
}
